import axios from '@/services/apiAxios'
import queryString from '@/utils/queryString';


export default {
    namespaced: true,
    state: {
        account: null,
        accounts: {},
        updata: false,
        accountsLookup: [],

    },
    mutations: {
        setAccount(state, payload) {
            state.account = payload;
        },
        setAccounts(state, payload) {
            state.accounts = Object.assign(state.accounts, payload);
        },
        updateAccounts(state, payload) {
            state.updata = payload;
        },
        resetAccount(state) {
            state.accounts = {};
        },
        concatAccountsToLookup(state, payload) {
            state.accountsLookup = [...state.accountsLookup, ...payload];
        },

    }, 
    actions: {
        storeAccount({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url:`${rootState.accounting.routePrefix}/accounts`,
                    data: payload,
                    headers: {
                        Authorization: `Bearer ${rootState.authentication.token}`,
                        'X-Request-ID': payload.idempotentKey
                    }
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })
            })
        },
        updateAccount({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "put",
                    url: `${rootState.accounting.routePrefix}/accounts/${payload.id}`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })

            })
        },
        removeAccount({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `${rootState.accounting.routePrefix}/accounts/${payload.id}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })

            })
        },
        removeAccounts({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `${rootState.accounting.routePrefix}/accounts`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })

            })
        },
        fetchAccount({ commit, rootState, dispatch }, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.accounting.routePrefix}/accounts/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setAccount', response.data);
                    resolve(response)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                } 
                );
            })
        },
        fetchAccounts({ commit, rootState, dispatch }, payload) {
            let query = queryString(payload);
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.accounting.routePrefix}/accounts?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setAccounts', response.data);
                    resolve(response.data)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                }
                );
            })
        },
        updateAccounts({ commit }, payload) {
            commit('updateAccounts', payload);
        },
        resetAccount({ commit }) {
            commit('resetAccount');
        },
        setAccountsLookup({ commit }, payload) {
            console.log(payload)
            commit('concatAccountsToLookup', payload);
        },


    }
}